"use client";
import type { ComponentPropsWithoutRef } from "react";
import { useFeatureHost } from "./use-feature-host";

export function FeatureLink(
  props: ComponentPropsWithoutRef<"a"> & { readonly href: string },
) {
  return useFeatureHost().renderLink(props);
}
